import {ISelectItem} from '../../../shared/types';

export const DropDownMenuOptions: ISelectItem[] = [
  {key: 1, value: 'false', isSelected: true, text: 'Opaque'},
  {
    key: 2,
    value: 'true',
    isSelected: false,
    text: 'Transparent',
  },
];

export const LOCATION_MAP: Record<string, number> = {
  'top-Left': 0,
  'top-Center': 1,
  'top-Right': 2,
  'bottom-Left': 3,
  'bottom-Center': 4,
  'bottom-Right': 5,
};
